import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-5d85976a")

_pushScopeId("data-v-5d85976a")
const _hoisted_1 = { class: "main-table" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("提交审核")
const _hoisted_3 = { key: 0 }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "ant-upload-text" }, "上传", -1)
const _hoisted_5 = { class: "img-list" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" 确定 ")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_a_select_option = _resolveComponent("a-select-option")
  const _component_a_select = _resolveComponent("a-select")
  const _component_a_form_item = _resolveComponent("a-form-item")
  const _component_a_button = _resolveComponent("a-button")
  const _component_a_form = _resolveComponent("a-form")
  const _component_a_table = _resolveComponent("a-table")
  const _component_a_textarea = _resolveComponent("a-textarea")
  const _component_plus_outlined = _resolveComponent("plus-outlined")
  const _component_a_upload = _resolveComponent("a-upload")
  const _component_a_modal = _resolveComponent("a-modal")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_a_form, {
      layout: "inline",
      style: {"margin-bottom":"10px"}
    }, {
      default: _withId(() => [
        _createVNode(_component_a_form_item, null, {
          default: _withId(() => [
            _createVNode(_component_a_select, {
              placeholder: "请选择模板",
              options: _ctx.templateList,
              style: {"width":"120px"},
              value: _ctx.filter.templateId,
              "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => (_ctx.filter.templateId = $event))
            }, {
              default: _withId(() => [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.templateList, (item) => {
                  return (_openBlock(), _createBlock(_component_a_select_option, {
                    key: item.value,
                    value: item.value
                  }, {
                    default: _withId(() => [
                      _createTextVNode(_toDisplayString(item.label), 1)
                    ]),
                    _: 2
                  }, 1032, ["value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["options", "value"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, null, {
          default: _withId(() => [
            _createVNode(_component_a_button, {
              type: "primary",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.visible = true))
            }, {
              default: _withId(() => [
                _hoisted_2
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_a_table, {
      scroll: _ctx.scroll,
      "data-source": _ctx.tableData,
      columns: _ctx.columns,
      "row-key": (record) => record.appId,
      pagination: false,
      "row-selection": _ctx.rowSelection,
      onChange: _ctx.handleTableChange
    }, {
      auditReason: _withId(({record}) => [
        _createVNode("div", {
          innerHTML: record.auditReason
        }, null, 8, ["innerHTML"])
      ]),
      _: 1
    }, 8, ["scroll", "data-source", "columns", "row-key", "row-selection", "onChange"]),
    _createVNode(_component_a_modal, {
      visible: _ctx.visible,
      "onUpdate:visible": _cache[4] || (_cache[4] = ($event: any) => (_ctx.visible = $event)),
      title: "提交审核"
    }, {
      footer: _withId(() => [
        _createVNode(_component_a_button, {
          key: "back",
          onClick: _ctx.close
        }, {
          default: _withId(() => [
            _hoisted_6
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_a_button, {
          key: "submit",
          type: "primary",
          loading: _ctx.loading,
          onClick: _ctx.postAudit
        }, {
          default: _withId(() => [
            _hoisted_7
          ]),
          _: 1
        }, 8, ["loading", "onClick"])
      ]),
      default: _withId(() => [
        _createVNode(_component_a_form, { model: _ctx.formModal }, {
          default: _withId(() => [
            _createVNode(_component_a_form_item, { label: "反馈内容" }, {
              default: _withId(() => [
                _createVNode(_component_a_textarea, {
                  modelValue: _ctx.formModal.feedbackInfo,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.formModal.feedbackInfo = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "反馈截图" }, {
              default: _withId(() => [
                _createVNode(_component_a_upload, {
                  accept: "application/gif,image/png,image/jpeg,.bmp",
                  "show-upload-list": false,
                  customRequest: _ctx.customUploadRequest,
                  "list-type": "picture-card"
                }, {
                  default: _withId(() => [
                    (_ctx.formModal.feedbackStuff.length < 8)
                      ? (_openBlock(), _createBlock("div", _hoisted_3, [
                          _createVNode(_component_plus_outlined),
                          _hoisted_4
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["customRequest"])
              ]),
              _: 1
            }),
            _createVNode("div", _hoisted_5, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.formModal.feedbackStuff, (item) => {
                return (_openBlock(), _createBlock("img", {
                  src: item,
                  key: item
                }, null, 8, ["src"]))
              }), 128))
            ])
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
})